import { mb, p } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';
import { StyledCTAButton } from '../common/styles';

export const StyledHeroBanner = styled.div`
  background-color: ${({ theme }) => theme.palette.backgroundAccentDeposit};
  border-radius: ${({ theme }) => theme.defaultBorderRadius};
  ${p(['lg', 'xl'])}
  ${mb('xl')}
`;

export const StyledHeroCTAButton = styled(StyledCTAButton)`
  white-space: wrap;

  && {
    // To support French, we need to disable the
    // auto capitalization of the button text.
    text-transform: none;
  }
`;

export const StyledFaqHeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.lg};
`;
